import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/pages/home/components/Header";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

/* ──────────────────────── data ──────────────────────── */

interface DocumentItem {
  title: string;
  category: string;
  href: string;
  isExternal?: boolean;
}

interface DocCategory {
  id: string;
  title: string;
  icon: string;
  externalHref: string;
  docs: DocumentItem[];
}

const categoryData: DocCategory[] = [
  {
    id: "annual-reports",
    title: "Rapports annuels",
    icon: "ri-file-chart-line",
    externalHref: "https://www.mpfcanada.ca/resources/annual-reports/",
    docs: [
      { title: "Rapport annuel 2025", category: "Rapport annuel", href: "/wp-content/2026/MPFCanada_AR_2025_FR%20FINAL-s.pdf" },
      { title: "Rapport annuel 2024", category: "Rapport annuel", href: "/wp-content/uploads/2025/07/MPF_AR_2024_FRE-FINAL-s.pdf" },
      { title: "Rapport annuel 2023", category: "Rapport annuel", href: "/wp-content/uploads/2024/07/MPF_AR_2023_FRE-Final_FINAL-s.pdf" },
      { title: "Rapport annuel 2022", category: "Rapport annuel", href: "/wp-content/uploads/2023/06/MPF_AR_2022_FRE_FINAL-s.pdf" },
      { title: "Rapport annuel 2021", category: "Rapport annuel", href: "/wp-content/uploads/2022/06/MPF_AR_2021_FRE_FINAL-s.pdf" },
      { title: "Rapport annuel 2020", category: "Rapport annuel", href: "/wp-content/uploads/2021/06/MPF_AR_2020_FRE.pdf" },
      { title: "Rapport annuel 2019", category: "Rapport annuel", href: "/wp-content/uploads/2020/06/MPF_AR2019_FRE-Final_s.pdf" },
      { title: "Rapport annuel 2018", category: "Rapport annuel", href: "/wp-content/uploads/2019/07/MPF_AR2018_FRE.pdf" },
      { title: "Rapport annuel 2017", category: "Rapport annuel", href: "/wp-content/uploads/2018/07/2017_MPFC_AR-French_FINAL-s.pdf" },
      { title: "Rapport annuel 2016", category: "Rapport annuel", href: "/wp-content/uploads/2017/07/2016_MPFC_AR_French%20FINAL-s.pdf" },
      { title: "Rapport annuel 2015", category: "Rapport annuel", href: "/wp-content/uploads/2016/07/Rapport-annuel-2015-FINAL-s.pdf" },
      { title: "Rapport annuel 2014", category: "Rapport annuel", href: "/wp-content/uploads/2016/03/MPF_AR_2014-FrenchAODA.pdf" },
      { title: "Rapport annuel 2013", category: "Rapport annuel", href: "/wp-content/uploads/2016/03/MPF_AR_2013-FrenchAODA.pdf" },
    ],
  },
  {
    id: "newsletters",
    title: "Bulletins d'information",
    icon: "ri-mail-line",
    externalHref: "https://www.mpfcanada.ca/resources/newsletters/",
    docs: [
      { title: "Bulletin AVRIL 2026", category: "Bulletin", href: "/wp-content/uploads/nl-202604/french.html" },
      { title: "Bulletin DÉCEMBRE 2025", category: "Bulletin", href: "/wp-content/uploads/nl-202512/french.html" },
      { title: "Bulletin SEPTEMBRE 2025", category: "Bulletin", href: "/wp-content/uploads/nl-202509/french.html" },
      { title: "Bulletin JUILLET 2025", category: "Bulletin", href: "/wp-content/uploads/nl-202507/french.html" },
      { title: "Bulletin MARS 2025", category: "Bulletin", href: "/wp-content/uploads/nl-202504/french.html" },
      { title: "Bulletin DÉCEMBRE 2024", category: "Bulletin", href: "/wp-content/uploads/nl-202412/french.html" },
      { title: "Bulletin JUILLET 2024", category: "Bulletin", href: "/wp-content/uploads/nl-202407/french.html" },
      { title: "Bulletin MARS 2024", category: "Bulletin", href: "/wp-content/uploads/nl-202403/french.html" },
      { title: "Bulletin DÉCEMBRE 2023", category: "Bulletin", href: "/wp-content/uploads/nl-202312/french.html" },
      { title: "Bulletin SEPTEMBRE 2023", category: "Bulletin", href: "/wp-content/uploads/nl-202309/french.html" },
      { title: "Bulletin JUILLET 2023", category: "Bulletin", href: "/wp-content/uploads/nl-202307/french.html" },
      { title: "Bulletin MARS 2023", category: "Bulletin", href: "/wp-content/uploads/nl-202303/french.html" },
      { title: "Bulletin DÉCEMBRE 2022", category: "Bulletin", href: "/wp-content/uploads/nl-202212/french.html" },
      { title: "Bulletin OCTOBRE 2022", category: "Bulletin", href: "/wp-content/uploads/nl-202210/french.html" },
      { title: "Bulletin JUILLET 2022", category: "Bulletin", href: "/wp-content/uploads/nl-202207/french.html" },
      { title: "Bulletin MARS 2022", category: "Bulletin", href: "/wp-content/uploads/nl-202203/french.html" },
      { title: "Bulletin DÉCEMBRE 2021", category: "Bulletin", href: "/wp-content/uploads/nl-202112/french.html" },
      { title: "Bulletin NOVEMBRE 2021", category: "Bulletin", href: "/wp-content/uploads/nl-202111/french.html" },
      { title: "Bulletin JUIN 2021", category: "Bulletin", href: "/wp-content/uploads/nl-202106/french.html" },
      { title: "Bulletin MARS 2021", category: "Bulletin", href: "/wp-content/uploads/nl-202103/french.html" },
      { title: "Bulletin DÉCEMBRE 2020", category: "Bulletin", href: "/wp-content/uploads/nl-202012/french.html" },
      { title: "Bulletin OCTOBRE 2020", category: "Bulletin", href: "/wp-content/uploads/nl-202010/french.html" },
      { title: "Bulletin JUIN 2020", category: "Bulletin", href: "/wp-content/uploads/nl-202006/french.html" },
      { title: "Bulletin DÉCEMBRE 2019", category: "Bulletin", href: "/wp-content/uploads/nl-201912/french.html" },
      { title: "Bulletin SEPTEMBRE 2019", category: "Bulletin", href: "/wp-content/uploads/nl-201909/french.html" },
      { title: "Bulletin JUIN 2019", category: "Bulletin", href: "/wp-content/uploads/nl-201906/french.html" },
      { title: "Bulletin MARS 2019", category: "Bulletin", href: "/wp-content/uploads/nl-201903/french.html" },
      { title: "Bulletin DÉCEMBRE 2018", category: "Bulletin", href: "/wp-content/uploads/nl-201901/french.html" },
      { title: "Bulletin OCTOBRE 2018", category: "Bulletin", href: "/wp-content/uploads/nl-201810/french.html" },
      { title: "Bulletin août 2018", category: "Bulletin", href: "/wp-content/uploads/nl-201808/french.html" },
      { title: "Bulletin avril 2018", category: "Bulletin", href: "/wp-content/uploads/nl-201804/french.html" },
      { title: "Bulletin décembre 2017", category: "Bulletin", href: "/wp-content/uploads/nl-201712/french.html" },
      { title: "Bulletin novembre 2017", category: "Bulletin", href: "/wp-content/uploads/nl-201711/french.html" },
      { title: "Bulletin août 2017", category: "Bulletin", href: "/wp-content/uploads/nl-201708/french.html" },
      { title: "Bulletin avril 2017", category: "Bulletin", href: "/wp-content/uploads/2017/04/MPF-April-2017-French-Newsletter.pdf" },
      { title: "Bulletin décembre 2016", category: "Bulletin", href: "/wp-content/uploads/2016/12/MPF-DECEMBER-2016-French-Newsletter.pdf" },
      { title: "Bulletin octobre 2016", category: "Bulletin", href: "/wp-content/uploads/2016/11/MPF-OCTOBER-2016-French-Newsletter.pdf" },
      { title: "Bulletin juillet 2016", category: "Bulletin", href: "/wp-content/uploads/2016/07/MPF-JULY-2016-French-Newsletter.pdf" },
      { title: "Bulletin avril 2016", category: "Bulletin", href: "/wp-content/uploads/2016/05/Enconcert-Avril-2016.pdf" },
      { title: "Bulletin juillet 2014", category: "Bulletin", href: "/wp-content/uploads/2016/03/enconcert-July2014-AODA.pdf" },
      { title: "Bulletin juin 2013", category: "Bulletin", href: "/wp-content/uploads/2016/03/EnConcert-Juin2013.pdf" },
      { title: "Bulletin automne 2012", category: "Bulletin", href: "/wp-content/uploads/2016/03/enConcert-50e-anniversaire.pdf" },
      { title: "Bulletin février 2012", category: "Bulletin", href: "/wp-content/uploads/2016/03/EnConcert-Fevrier2012.pdf" },
      { title: "Bulletin automne 2010", category: "Bulletin", href: "/wp-content/uploads/2016/03/InConcert-Fall-2010_French.pdf" },
      { title: "Bulletin automne 2009", category: "Bulletin", href: "/wp-content/uploads/2016/03/InConcert-Fall-2009-French.pdf" },
      { title: "Bulletin hiver 2008", category: "Bulletin", href: "/wp-content/uploads/2016/03/Winter-2008-09-Newsletter.pdf" },
      { title: "Bulletin septembre 2007", category: "Bulletin", href: "/wp-content/uploads/2016/03/AFM-EPW-NewsletterF5-Aug1.pdf" },
      { title: "Bulletin automne 2004", category: "Bulletin", href: "/wp-content/uploads/2016/03/AFM-NewsFr-N5-Fall-2004-Final.pdf" },
      { title: "Bulletin décembre 2003", category: "Bulletin", href: "/wp-content/uploads/2016/03/December-2003-French.pdf" },
      { title: "Bulletin automne 2003", category: "Bulletin", href: "/wp-content/uploads/2016/03/AFM_NewsFr_N7381.pdf" },
    ],
  },
  {
    id: "forms",
    title: "Formulaires",
    icon: "ri-file-download-line",
    externalHref: "https://www.mpfcanada.ca/resources/forms/",
    docs: [
      { title: "Renseignements du membre – Changement de bénéficiaire", category: "Formulaires", href: "/wp-content/uploads/2016/03/Coordonnees-du-participant-Changement-de-beneficiaire.pdf" },
      { title: "Avis de changement d'adresse", category: "Formulaires", href: "/wp-content/uploads/2016/03/Avis-de-changement-dadresse.pdf" },
      { title: "Demande de formulaire de retraite", category: "Formulaires", href: "/wp-content/uploads/2016/03/Demande-de-service-de-la-rente.pdf" },
    ],
  },
  {
    id: "what-happens-if",
    title: "Qu'arrive-t-il si?",
    icon: "ri-question-line",
    externalHref: "https://www.mpfcanada.ca/resources/what-happens-if/",
    docs: [
      { title: "Je demande ma retraite après 71 ans?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2023/10/WhatHappensifPensionafterage71_FR%20FINAL-s.pdf" },
      { title: "Je veux changer de bénéficiaire?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2022/08/What_Happens_If_I_Change_my_Beneficiary_Fr_FINAL.pdf" },
      { title: "Je décède avant ou après avoir commencé à recevoir ma prestation?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2020/07/Quarrive-t-il_si_je_meurs_je_meurs_avant_-_apre_FINAL-s.pdf" },
      { title: "Je deviens invalide?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2018/11/MPF_WhatHappensIf-Disabled_FRE_FINAL-s.pdf" },
      { title: "Je divorce?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2017/07/MPF_WhatHappensif_Divorced_French.pdf" },
      { title: "Je quitte le milieu de la musique (et si j'y reviens)", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2017/07/WhathappensIfIleaveMusicBus-French%20FINAL-s.pdf" },
      { title: "Je travaille aux États-Unis?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2018/06/French_MPF_WhatHappensIf-Work_in_the_US_FINAL-s.pdf" },
      { title: "Je continue à travailler (ou je retourne au travail) pendant que je reçois ma prestation?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2022/02/MPFC_What_Happens_If_I_Continue_Working_after_My_Pension_Starts-FR_FINAL-s.pdf" },
      { title: "Je demande une retraite anticipée?", category: "Qu'arrive-t-il si?", href: "/wp-content/uploads/2021/09/MPF_WhatHappensIf-RetireEarly_Fr_FINAL-s.pdf" },
    ],
  },
  {
    id: "things-you-need-to-know",
    title: "Ce que vous devez savoir",
    icon: "ri-lightbulb-line",
    externalHref: "https://www.mpfcanada.ca/resources/things-you-need-to-know/",
    docs: [
      { title: "Je veux déposer une plainte auprès de la Caisse de retraite des musiciens du Canada?", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2025/09/Things-You-Need-to-Know-Appeals_Fr_FINAL-s.pdf" },
      { title: "Ne laissez pas l'inflation assombrir votre retraite", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2022/07/Things_You_Need_to_Know-Inflation_FR_FINAL-s.pdf" },
      { title: "Tenir vos coordonnées à jour auprès du Bureau de la Caisse", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2020/08/MPFC_2020_Things_You_Need_To_Know_Contact_Info_FINAL_FR.pdf" },
      { title: "Exigences contractuelles pour les chefs", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2022/02/MPF_ThingstoKnow-ContractRequirements_FRE_FINAL-s.pdf" },
      { title: "Qu'est-ce que l'acquisition des droits?", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2017/07/MPF_What-is-Vesting_French.pdf" },
      { title: "Ce que font les fiduciaires de la Caisse", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2017/11/MPF_Things_You_need_to_know-French_FINAL.pdf" },
      { title: "Cotisations", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2018/10/Things_You_Need_to_Know-Contributions-French_FINAL-s.pdf" },
      { title: "À propos de la demande de prestation de retraite", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2019/08/MPFC_Things_You_Need_to_Know_About_Applying_for_Your_Pension-FR_FINAL-s.pdf" },
      { title: "Les fiduciaires modifient le régime pour aider pendant la COVID-19", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2021/10/2021-Things_You_Need_To_Know_COVID-19_FINAL-fr.pdf" },
      { title: "Cotisations de retraite non admissibles", category: "Ce que vous devez savoir", href: "/wp-content/uploads/2023/06/Things-You-Need-to-Know-Ineligible-Contributions-FR-03-FINAL-s.pdf" },
    ],
  },
  {
    id: "miscellaneous",
    title: "Divers",
    icon: "ri-folder-line",
    externalHref: "https://www.mpfcanada.ca/resources/miscellaneous/",
    docs: [
      { title: "Politique de confidentialité (en vigueur le 1er janvier 2004)", category: "Divers", href: "/wp-content/uploads/2016/03/mpf-privacy-fr.pdf" },
      { title: "Brochure générale", category: "Divers", href: "/wp-content/uploads/2021/03/2021_MPFCanada_Brochure-French_FINAL-s.pdf" },
    ],
  },
  {
    id: "links",
    title: "Liens",
    icon: "ri-link",
    externalHref: "https://www.mpfcanada.ca/resources/links/",
    docs: [
      { title: "Fédération canadienne des musiciens", category: "Liens", href: "http://www.cfmusicians.org/?lc=fr_CA", isExternal: true },
      { title: "Services Canada", category: "Liens", href: "https://www.canada.ca/fr/emploi-developpement-social/ministere/portefeuille/service-canada.html", isExternal: true },
    ],
  },
  {
    id: "rrsp-comparisons",
    title: "Comparaisons REER",
    icon: "ri-scales-line",
    externalHref: "https://www.mpfcanada.ca/resources/rrsp-comparisons/",
    docs: [
      { title: "Comparaisons REER", category: "Comparaisons REER", href: "/wp-content/uploads/2019/08/CRMC-Comparaisons-avec-les-REERs.pdf" },
    ],
  },
  {
    id: "somepp-notice",
    title: "Avis SOMEPP",
    icon: "ri-file-warning-line",
    externalHref: "https://www.mpfcanada.ca/resources/somepp-notice/",
    docs: [
      { title: "Avis SOMEPP", category: "Avis SOMEPP", href: "/wp-content/uploads/2025/11/MPFC%20SOMEPP%20Notice%202025%20French.html" },
    ],
  },
  {
    id: "key-plan-definitions",
    title: "Définitions clés du régime",
    icon: "ri-book-open-line",
    externalHref: "https://www.mpfcanada.ca/resources/understanding-key-plan-definitions/",
    docs: [
      { title: "Comprendre les définitions clés du régime", category: "Définitions clés", href: "/wp-content/uploads/2020/10/MPFC_Definitions_FR_FINAL.pdf" },
      { title: "Glossaire des termes", category: "Définitions clés", href: "/wp-content/uploads/2016/04/Glossary-french.pdf" },
    ],
  },
];

/* ──────────────────────── sub-components ──────────────────────── */

function DocumentRow({ doc }: { doc: DocumentItem }) {
  const { t } = useTranslation();
  return (
    <a
      href={doc.href}
      target="_blank"
      rel={doc.isExternal ? "nofollow" : "noopener noreferrer"}
      className="flex items-center justify-between gap-3 py-3 px-3 rounded-md border-b border-gray-100/70 last:border-b-0 hover:bg-[#e1edf5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1a8fc1]/40 focus-visible:ring-offset-0 transition-colors duration-200 cursor-pointer group"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded bg-[#0d1f4c]/6">
          {doc.isExternal ? (
            <i className="ri-external-link-line text-xs text-[#0d1f4c]"></i>
          ) : (
            <i className="ri-file-pdf-2-line text-xs text-[#0d1f4c]"></i>
          )}
        </div>
        <h4 className="text-sm font-medium text-[#0d1f4c] truncate">
          {doc.title}
        </h4>
      </div>
      <span className="flex-shrink-0 flex items-center gap-1.5 text-xs font-medium text-[#1a8fc1] border border-[#1a8fc1]/30 bg-white group-hover:bg-[#e8f4fa] group-hover:border-[#1a8fc1]/60 group-hover:text-[#0d6e9e] px-2.5 py-1 rounded-md transition-all duration-200 whitespace-nowrap pointer-events-none">
        {doc.isExternal ? t("resources.open") : t("resources.view")}
        <i className={`${doc.isExternal ? "ri-external-link-line" : "ri-arrow-right-line"} text-xs`}></i>
      </span>
    </a>
  );
}

/* ──────────────────────── page ──────────────────────── */

export default function FrResources() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getCategoryFromUrl = (): string => {
    const params = new URLSearchParams(location.search);
    const cat = params.get("category");
    if (cat && categoryData.some((c) => c.id === cat)) return cat;
    const hash = location.hash.replace("#", "");
    if (hash && categoryData.some((c) => c.id === hash)) return hash;
    return "annual-reports";
  };

  const [activeId, setActiveId] = useState(getCategoryFromUrl);
  const [contentKey, setContentKey] = useState(0);

  useEffect(() => {
    const newId = getCategoryFromUrl();
    setActiveId(newId);
  }, [location.search, location.hash]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCategorySelect = (id: string) => {
    if (id === activeId) return;
    setActiveId(id);
    setContentKey((prev) => prev + 1);
    navigate({ search: `?category=${id}` }, { replace: true });
  };

  const activeCategory = categoryData.find((c) => c.id === activeId) ?? categoryData[0];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Navbar />

      <main className="flex-1">
        <section className="w-full bg-[#0d1f4c] py-10">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
              <span className="text-[#7ec8e3] text-xs font-semibold tracking-widest uppercase">
                {t("resources.pageLabel")}
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              {t("resources.pageTitle")}
            </h1>
            <p className="text-base text-white/70 max-w-[560px]">
              {t("resources.pageDesc")}
            </p>
          </div>
        </section>

        <div className="lg:hidden w-full bg-[#f4f8fc] border-b border-gray-100 py-4">
          <div className="max-w-[1200px] mx-auto px-6">
            <label htmlFor="cat-select" className="sr-only">{t("resources.selectCategory")}</label>
            <select
              id="cat-select"
              value={activeId}
              onChange={(e) => handleCategorySelect(e.target.value)}
              className="w-full text-sm font-medium text-[#0d1f4c] bg-white border border-gray-200 rounded-lg px-4 py-3 appearance-none cursor-pointer focus:outline-none focus:border-[#1a8fc1] focus:ring-2 focus:ring-[#1a8fc1]/20"
              style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%230d1f4c' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 12px center",
                paddingRight: "40px",
              }}
            >
              {categoryData.map((cat) => (
                <option key={cat.id} value={cat.id}>{cat.title}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="w-full bg-white">
          <div className="max-w-[1200px] mx-auto px-6 flex flex-col lg:flex-row gap-0">
            <aside className="hidden lg:block w-[260px] flex-shrink-0 border-r border-gray-100 py-8 pr-6">
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
                {t("resources.categories")}
              </h3>
              <nav className="space-y-0.5">
                {categoryData.map((cat) => {
                  const isActive = cat.id === activeId;
                  return (
                    <button
                      key={cat.id}
                      onClick={() => handleCategorySelect(cat.id)}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-left text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
                        isActive
                          ? "bg-[#e8f2f9] text-[#0d1f4c] font-semibold border-l-2 border-[#1a8fc1]"
                          : "text-gray-600 hover:bg-[#f4f8fb] hover:text-[#0d1f4c] font-normal border-l-2 border-transparent"
                      }`}
                    >
                      <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ${isActive ? "text-[#1a8fc1]" : "text-gray-400"}`}>
                        <i className={`${cat.icon} text-sm`}></i>
                      </span>
                      <span className="truncate">{cat.title}</span>
                      {isActive && (
                        <span className="ml-auto w-1.5 h-4 rounded-full bg-[#1a8fc1] flex-shrink-0"></span>
                      )}
                    </button>
                  );
                })}
              </nav>
            </aside>

            <div id="resources-content" className="flex-1 min-w-0 py-8 lg:pl-8 scroll-mt-14" key={contentKey}>
              <div className="mb-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-5 h-0.5 bg-[#1a8fc1]"></div>
                  <h2 className="text-lg font-bold text-[#0d1f4c]">
                    {activeCategory.title}
                  </h2>
                </div>
                <p className="text-sm text-gray-500">
                  {activeCategory.docs.length} {activeCategory.docs.length !== 1 ? "documents" : "document"}
                </p>
              </div>

              <div className="bg-[#fafbfd] rounded-lg border border-gray-100 p-5 animate-content-switch">
                {activeCategory.docs.map((doc) => (
                  <DocumentRow key={doc.title} doc={doc} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}